module.exports = __webpack_public_path__ + "static/media/rmu_logo.b1b02880.svg";